import Vue from 'vue';
import BootstrapVue from 'bootstrap-vue';

// Import the styles directly. (Or you could add them via script tags.)
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';

import App from './App.vue';
import { router } from './router';
import { store } from './store';
import Tools from './tools'
import DataUrl from './data/url'
import Language from './language/index.js'
import Language1 from './language/index_s1.js'
import Language2 from './language/index_s2.js'
import Language3 from './language/index_s3.js'
import Language4 from './language/index_s4.js'
import Language5 from './language/index_s5.js'
import Language6 from './language/index_s6.js'
import Language7 from './language/index_s7.js'
import Language8 from './language/index_s8.js'
import Language9 from './language/index_s9.js'
import Language10 from './language/index_s10.js'
import Language11 from './language/index_s11.js'
import Language12 from './language/index_s12.js'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faDownload } from '@fortawesome/free-solid-svg-icons/faDownload'
import { faHandPointRight } from '@fortawesome/free-solid-svg-icons/faHandPointRight'
import { faVolumeMute } from '@fortawesome/free-solid-svg-icons/faVolumeMute'
import { faVolumeUp } from '@fortawesome/free-solid-svg-icons/faVolumeUp'
import { faStar } from '@fortawesome/free-solid-svg-icons/faStar'
import { faCheck } from '@fortawesome/free-solid-svg-icons/faCheck'
import { faCaretDown } from '@fortawesome/free-solid-svg-icons/faCaretDown'
import { faPlay } from '@fortawesome/free-solid-svg-icons/faPlay'
import { faPause } from '@fortawesome/free-solid-svg-icons/faPause'
import { faStop } from '@fortawesome/free-solid-svg-icons/faStop'
import { faPrint } from '@fortawesome/free-solid-svg-icons/faPrint'
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons/faTrashAlt'
import { faEdit } from '@fortawesome/free-solid-svg-icons/faEdit'
import { faSave } from '@fortawesome/free-solid-svg-icons/faSave'
import { faUndo } from '@fortawesome/free-solid-svg-icons/faUndo'
import { faRedo } from '@fortawesome/free-solid-svg-icons/faRedo'
import { faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons/faExternalLinkAlt'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import VueYouTubeEmbed from 'vue-youtube-embed'

library.add(faDownload);
library.add(faHandPointRight);
library.add(faVolumeMute);
library.add(faVolumeUp);
library.add(faStar);
library.add(faCheck);
library.add(faCaretDown);
library.add(faPlay);
library.add(faPause);
library.add(faStop);
library.add(faPrint);
library.add(faTrashAlt);
library.add(faEdit);
library.add(faSave);
library.add(faUndo);
library.add(faRedo);
library.add(faExternalLinkAlt);

Vue.component('font-awesome-icon', FontAwesomeIcon)


Vue.config.productionTip = true;
Vue.use(BootstrapVue);
//Vue.use(VueYouTubeEmbed, { global: false })  // if you don't want install the component globally
Vue.use(VueYouTubeEmbed);

Vue.mixin(Tools);
Vue.mixin(DataUrl);
Vue.mixin(Language);
Vue.mixin(Language1);
Vue.mixin(Language2);
Vue.mixin(Language3);
Vue.mixin(Language4);
Vue.mixin(Language5);
Vue.mixin(Language6);
Vue.mixin(Language7);
Vue.mixin(Language8);
Vue.mixin(Language9);
Vue.mixin(Language10);
Vue.mixin(Language11);
Vue.mixin(Language12);

// We inject router and store into our Vue instance so it can be accessed globally
new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app');
